export const data = [
  {
    title: "Introduction",
    level: 1,
    content: "The event-specific categories for patient safety surveillance in CFS-H are designed to provide data on adverse events collected through retrospective review of medical records.",
  },
  {
    level: 1,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [2491, 2492]
      },
      {
        title: "Event Details",
        level: 2,
        cards: [2493, 2499],
        children: [
          {
            title: "Blood or Blood Product",
            mainContentTitle: "Blood or Blood Product Event",
            level: 3,
            content: "A blood or blood product adverse event is one in which administration of a blood product results in harm to a patient. It includes adverse reactions during or following administration without any apparent incorrect action.",
            cardsPrologue: "For more information about the Blood or Blood Product module, please refer to the following document:",
            cards: [2496]
          },
          {
            title: "Birth - Maternal",
            level: 3,
            mainContentTitle: "Birth - Maternal Event",
            content: "A Birth-Maternal event is an adverse maternal or fetal outcome that occurs during labor and/or birth.",
            cardsPrologue: "For more information about the Birth-Maternal module, please refer to the following document:",
            cards: [2494]
          },
          {
            title: "Birth - Neonatal",
            level: 3,
            mainContentTitle: "Birth - Neonatal Event",
            content: "A Birth-Neonatal event is an adverse neonatal outcome that occurs during labor and/or birth.",
            cardsPrologue: "For more information about the Birth-Neonatal module, please refer to the following document:",
            cards: [2495]
          },
          {
            title: "Device or Medical/Surgical Supply, including HIT",
            level: 3,
            mainContentTitle: "Device or Medical/Surgical Supply, including Health information technology (HIT) Event",
            content: "A device event involves a defect, failure, or incorrect use of a device that results in harm to a patient. (Infections associated with use of a device are described in the Healthcare-associated Infection event description.)",
            cardsPrologue: "For more information about the Device module, please refer to the following document:",
            cards: [2497]
          },
          {
            title: "Fall",
            level: 3,
            mainContentTitle: "Fall Event",
            content: "A fall event involves one or more falls during stay, with or without injury, whether or not fall was assisted." +
              " Fall may be indicated by \"fall\", \"patient found on floor\", or other similar notation." + 
              " A fall is a sudden, unintended, downward displacement of a patient's body to the ground or other object (e.g., onto a bed, chair, or bedside mat). If more than one fall during stay, only most serious event will be captured.",
            cardsPrologue: "For more information about the Fall module, please refer to the following document:",
            cards: [2498]
          },
          {
            title: "Hospital-Acquired Infection (HAI)",
            level: 3,
            mainContentTitle: "Hospital-Acquired Infection (HAI) Event",
            content: "The Hospital-Acquired Infection (HAI) module consists of eight different event descriptions which address infections acquired within a hospital that are not present on admission.",
            cardsPrologue: "For more information about the HAI module, please refer to the following documents:",
            cards: [2500, 2501, 2502, 2503, 2504, 2506, 2507, 2505]
          },
          {
            title: "Medication",
            level: 3,
            mainContentTitle: "Medication Event",
            content: "An adverse medication event is one in which administration of a medication results in harm to a patient. Included are adverse reactions during or following administration without any apparent incorrect action.",
            cardsPrologue: "For more information about the Medication Product module, please refer to the following document:",
            cards: [2508]
          },
          {
            title: "Other Adverse Event",
            level: 3,
            content: "An \"other adverse event\" involves a harm within a hospital setting that is not covered by another structured surveillance module.",
            cardsPrologue: "For more information about the Other Adverse Event module, please refer to the following document:",
            cards: [2509]
          },
          {
            title: "Pressure Injury",
            level: 3,
            mainContentTitle: "Pressure Injury Event",
            content: "A pressure injury, also known as a pressure ulcer, is localized damage to the skin and underlying soft tissue usually over a bony prominence or related to a medical or other device.",
            cardsPrologue: "For more information about the Pressure Injury module, please refer to the following document:",
            cards: [2510]
          },
          {
            title: "Surgery or Anesthesia",
            level: 3,
            mainContentTitle: "Surgery or Anesthesia Event",
            content: "A surgery or anesthesia event is an event associated with a surgical procedure in an operating room (OR) or an event associated with the administration of anesthesia or procedural sedation.",
            cardsPrologue: "For more information about the Surgery or Anesthesia module, please refer to the following document:",
            cards: [2511]
          },
          {
            title: "Venous Thromboembolism (VTE)",
            level: 3,
            mainContentTitle: "Venous Thromboembolism Event",
            content: "Venous thromboembolism (VTE) comprises one or both of the following: (1) a deep vein thrombosis (DVT) or (2) a pulmonary embolism (PE).",
            cardsPrologue: "For more information about the Venous Thromboembolism (VTE) module, please refer to the following document:",
            cards: [2512]
          }
        ]
      }
    ]
  },

]